import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Parts} from "components";

const breadcrumbsStatic = [{
	name: 'Today Missing',
	url: '/helpdesks/missing_financial',
	icon: 'comments'
}];

class MissingFinancial extends Framework.Components.View {
	render() {
		return (
			<div className={'container-fluid'}>
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}/>
				<Parts.Tickers.HelpdeskTicker/>
				<Collections.MissingFinancialWorkflows
					history={this.props.history}
					roles={this.props.roles}
					reloadShell={this.props.reloadShell}
					onSessionCheck={() => this.props.rootState?.triggerAction?.('handleSessionCheck')}
				/>
			</div>
		);
	}
}

export default Framework.Components.withRootState(MissingFinancial);
